import {Pipe, PipeTransform} from '@angular/core';
import {UmpireIncidentType} from '@tisa-group/models';

@Pipe({
  name: 'incidentOccurrence',
  standalone: false,
})
export class IncidentOccurrencePipe implements PipeTransform {
  transform(
    incident: Record<string, unknown> & {
      occurrence_half: number;
      occurrence_minute: number;
      incident_type: UmpireIncidentType;
    },
  ): string | undefined {
    if (!incident) {
      return;
    }

    if (incident.incident_type === 'penalty') return '(K.)';

    if (incident.incident_type === 'own_goal') return '(SAM.)';

    return;
  }
}
